import { apiWrapper } from "@/services/api";
import store from "@/store";

export const usedPasses = async () => {
  try {
    const resp = await apiWrapper("POST", `used_passes`, []);
    store.commit("ticketing/setPass", resp.data[0]);
    return resp.data[0];
  } catch (err) {
    console.log("ERROR!!! usedPasses");
    throw err;
  }
};
